import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Trash2Icon, XIcon } from 'lucide-react';
export function DeleteToast({
  open,
  message = 'La operación se ha movido a la papelera.',
  onUndo,
  onDismiss
}: {
  open: boolean;
  message?: string;
  onUndo: () => void;
  onDismiss: () => void;
}) {
  useEffect(() => {
    if (!open) return;
    const timer = window.setTimeout(onDismiss, 8000);
    return () => window.clearTimeout(timer);
  }, [open, onDismiss]);
  return <AnimatePresence data-id="element-381" data-mp="3o2ohptqou730">
      {open && <motion.div role="status" initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed bottom-5 left-1/2 z-[90] flex max-w-[92vw] -translate-x-1/2 items-start gap-3 rounded-xl border border-line bg-white px-4 py-3 shadow-pop" data-id="element-382" data-mp="3o3pwa86wxbph">
          <Trash2Icon className="mt-0.5 h-4 w-4 shrink-0 text-ink-soft" data-id="element-383" data-mp="35dq9jryjo8p8" />
          <p className="text-[12.5px] leading-relaxed text-ink" data-id="element-384" data-mp="2xjxbp7hsvpte">
            {message}
            <span className="text-ink-soft" data-id="element-385" data-mp="2tj522d50niwl"> Se eliminará definitivamente dentro de 30 días.</span>
          </p>
          <button type="button" onClick={onUndo} className="shrink-0 rounded-lg bg-ink px-2.5 py-1.5 text-[12px] font-medium text-white hover:bg-black" data-id="element-386" data-mp="37j62xsla6qc2">
            Deshacer
          </button>
          <button type="button" onClick={onDismiss} className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-ink-soft hover:bg-surface" aria-label="Cerrar aviso" data-id="element-387" data-mp="29vxi7zt3tlb4">
            <XIcon className="h-3.5 w-3.5" data-id="element-388" data-mp="2jtbq3b0yp1rt" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}